// Port of the submitted iOS58 features/explore/landingTimeline.ts contract.
export function selectLandingTimeline(timelines, random = Math.random) {
  const shuffle = (items) => {
    const result = [...items];
    for (let index = result.length - 1; index > 0; index -= 1) {
      const other = Math.floor(random() * (index + 1));
      [result[index], result[other]] = [result[other], result[index]];
    }
    return result;
  };
  const interleave = (groups) => {
    const result = [];
    for (let index = 0; index < Math.max(0, ...groups.map((group) => group.length)); index += 1) {
      groups.forEach((group) => {
        if (group[index]) result.push(group[index]);
      });
    }
    return result;
  };
  const groups = shuffle(timelines).map((timeline) => [
    ...(timeline.rediscoveredAlbums || []),
    ...(timeline.openingAlbums || []),
  ]);
  const reviewed = shuffle(groups.flat().filter((item) => item.album.reviewCount > 0));
  const editorial = interleave(
    groups.map((group) =>
      group
        .filter((item) => item.album.reviewCount === 0 && item.source === 'APPLE_MUSIC_EDITORIAL')
        .sort(
          (a, b) =>
            (a.editorialRank ?? Number.MAX_SAFE_INTEGER) -
            (b.editorialRank ?? Number.MAX_SAFE_INTEGER),
        ),
    ),
  );
  const catalog = interleave(
    groups.map((group) =>
      group.filter(
        (item) =>
          item.album.reviewCount === 0 &&
          ['APPLE_MUSIC_API', 'POSTPOP_ACTIVITY'].includes(item.source),
      ),
    ),
  );
  const selected = [],
    ids = new Set();
  const add = (item) => {
    if (!item || ids.has(item.album.id) || selected.length >= 12) return;
    ids.add(item.album.id);
    selected.push(item);
  };
  for (let index = 0; index < 6; index += 1) {
    add(reviewed[index]);
    add(editorial[index]);
  }
  reviewed.slice(6).forEach(add);
  editorial.slice(6).forEach(add);
  catalog.forEach(add);
  return selected;
}
